import React from 'react';
import { createRoot } from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import AppWrapper from './AppWrapper';
import { AuthProvider } from './contexts/AuthContext';

// Google OAuth Client ID - configure in Google Cloud Console
// For development, you can set this in .env.local as REACT_APP_GOOGLE_CLIENT_ID
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const MissingConfigError = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    padding: '20px',
    textAlign: 'center',
    fontFamily: 'system-ui, -apple-system, sans-serif'
  }}>
    <h1 style={{ color: '#d32f2f', marginBottom: '16px' }}>Configuration Error</h1>
    <p style={{ color: '#666', maxWidth: '500px', lineHeight: 1.6 }}>
      Google Sign-In is not configured. Please set the <code style={{
        backgroundColor: '#f5f5f5',
        padding: '2px 6px',
        borderRadius: '4px'
      }}>REACT_APP_GOOGLE_CLIENT_ID</code> environment variable with your Google OAuth client ID.
    </p>
    <p style={{ color: '#888', marginTop: '16px', fontSize: '14px' }}>
      See the <a href="https://developers.google.com/identity/gsi/web/guides/get-google-api-clientid"
        target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2' }}>
        Google Identity documentation
      </a> for setup instructions.
    </p>
  </div>
);

const container = document.getElementById('root');
const root = createRoot(container!);

// Show error page if Google Client ID is not configured
if (!GOOGLE_CLIENT_ID) {
  console.error(
    'REACT_APP_GOOGLE_CLIENT_ID is not configured. ' +
    'Google Sign-In will not work. ' +
    'Set the environment variable to enable Google authentication.'
  );
  root.render(
    <React.StrictMode>
      <MissingConfigError />
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <AuthProvider>
          <AppWrapper />
        </AuthProvider>
      </GoogleOAuthProvider>
    </React.StrictMode>
  );
}
